import {
  ContatoIndicacao,
  EnumStatusIndicacao,
} from "src/app/enums/EnumContatoIndicacao";

export class IndicacoesModel {
  public enderecosEmailIndicar: string;

  public valorTabelaDesconto: number;
  public valorMaximoDesconto: number;
  public valorPlano: number;
  public dataProximoVencimento: Date;

  public indicacoes: ContatoIndicacao[];

  constructor() {
    this.indicacoes = new Array<ContatoIndicacao>();
  }

  public get valorDescontoIndicacoes(): number {
    let valor = 0;

    const qtdIndicacoes = this.indicacoes.filter(
      (i) => i.status.codigo === EnumStatusIndicacao.aprovado
    ).length;
    valor = qtdIndicacoes * this.valorTabelaDesconto;

    return valor > this.valorMaximoDesconto ? this.valorMaximoDesconto : valor;
  }
}
